import { render } from "./searchPageResultItemSkeleton.vue?vue&type=template&id=1466ac25&ts=true"
import script from "./searchPageResultItemSkeleton.vue?vue&type=script&lang=ts"
export * from "./searchPageResultItemSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__